import { useContext } from "react";
import ConfirmDialog from "../../../components/common/ConfirmDialog/ConfirmDialog";
import OpenableProps from "../../../helpers/openableProps";
import FieldLabelContext from "../../search/context/FieldLabelContext";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

export interface ResetHeadersConfirmationProps extends OpenableProps {
  submit: (values: Record<string, string>) => Promise<void>;
}

const ResetHeadersConfirmation = ({
  isOpen,
  setIsOpen,
  submit,
}: ResetHeadersConfirmationProps) => {
  const { t } = useTranslation("configureHeaders");
  const { reset } = useFormContext();
  const { fieldLabels } = useContext(FieldLabelContext);

  const resetToDefault = async () => {
    const newValues: Record<string, string> = {};
    Object.entries(fieldLabels).forEach(([fieldName, fieldLabel]) => {
      newValues[fieldName] = fieldLabel.defaultName ?? fieldName ?? "";
    });
    reset(newValues);
    await submit(newValues);
    setIsOpen(false);
  };

  return (
    <ConfirmDialog
      title={t("configureHeaders:resetHeadersToDefault")}
      action="reset headers to the default names"
      onConfirm={resetToDefault}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};

export default ResetHeadersConfirmation;
